/** Pass collect context into Company Analysis (Insights) when leaving Synthesis. */

export const COLLECT_INSIGHTS_PRELOAD_KEY = 'famla_collect_insights_preload';

export type CollectInsightsPreload = {
    collectionId: string;
    collectionName: string;
    mapIds: string[];
    linkedProcessId?: string | null;
    objectiveText?: string | null;
    /** When true (default from Synthesis), Insights uses synthesis-focused collect context. */
    synthesisOnly?: boolean;
};

export function saveCollectInsightsPreload(payload: CollectInsightsPreload): void {
    try {
        sessionStorage.setItem(COLLECT_INSIGHTS_PRELOAD_KEY, JSON.stringify(payload));
    } catch {
        /* ignore quota */
    }
}

export function readCollectInsightsPreload(): CollectInsightsPreload | null {
    try {
        const raw = sessionStorage.getItem(COLLECT_INSIGHTS_PRELOAD_KEY);
        if (!raw) return null;
        const parsed = JSON.parse(raw) as CollectInsightsPreload;
        if (!parsed?.collectionId) return null;
        return parsed;
    } catch {
        return null;
    }
}

export function clearCollectInsightsPreload(): void {
    try {
        sessionStorage.removeItem(COLLECT_INSIGHTS_PRELOAD_KEY);
    } catch {
        /* ignore */
    }
}
